(function () {
  'use strict';

  const ATTR_METHOD = 'Liefermethode';
  const ATTR_ABHOLTERMIN = 'Abholtermin';
  const ATTR_ABHOLTERMIN_DISPLAY = 'Abholtermin-Anzeige';
  const ABHOLUNG_CLASS = 'cart--abholung';

  // Pickup hours per weekday. Index = JS getDay() (0=Sun .. 6=Sat).
  // Empty array means closed.
  const SLOTS_BY_DOW = {
    0: [],
    1: [9, 10, 11, 12, 13, 14, 15],
    2: [9, 10, 11, 12, 13, 14, 15],
    3: [9, 10, 11, 12, 13, 14, 15],
    4: [9, 10, 11, 12, 13, 14, 15],
    5: [9, 10, 11, 12],
    6: []
  };

  const LEAD_HOURS = 1;
  const HORIZON_DAYS = 14;

  function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function todayDateString() {
    const d = new Date();
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
  }

  function maxDateString() {
    const d = new Date();
    d.setDate(d.getDate() + HORIZON_DAYS);
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
  }

  // Returns Date objects for every slot start that is (a) on this date's
  // weekday's permitted list and (b) at least LEAD_HOURS from now.
  function computeAvailableSlots(dateString) {
    if (!dateString) return [];
    const target = new Date(dateString + 'T00:00');
    if (isNaN(target.getTime())) return [];
    const dow = target.getDay();
    const hours = SLOTS_BY_DOW[dow] || [];
    if (hours.length === 0) return [];

    const earliest = new Date(Date.now() + LEAD_HOURS * 60 * 60 * 1000);

    return hours
      .map(function (h) {
        const slot = new Date(target);
        slot.setHours(h, 0, 0, 0);
        return slot;
      })
      .filter(function (slot) {
        return slot.getTime() >= earliest.getTime();
      });
  }

  // de-AT example: "Mi, 15. Mai 2026 um 14:00"
  function formatGermanDisplay(date) {
    if (!(date instanceof Date) || isNaN(date.getTime())) return '';
    const fmt = new Intl.DateTimeFormat('de-AT', {
      weekday: 'short',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
    const datePart = fmt.format(date).replace(/\.,/, ',');
    return datePart + ' um ' + pad2(date.getHours()) + ':' + pad2(date.getMinutes());
  }

  function parseAbholterminIso(iso) {
    if (typeof iso !== 'string' || iso.length === 0) return null;
    const match = iso.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
    if (!match) return null;
    const d = new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4]),
      Number(match[5]),
      0,
      0
    );
    if (isNaN(d.getTime())) return null;
    return d;
  }

  function isAbholterminExpired(iso) {
    const d = parseAbholterminIso(iso);
    if (!d) return false;
    return d.getTime() < Date.now();
  }

  function buildIsoString(dateString, hourString) {
    if (!dateString || !hourString) return '';
    return dateString + 'T' + hourString;
  }

  // Pending user-initiated cart-attribute write. Prevents applyState() from
  // reading a stale /cart.js mid-write and clobbering the UI. Cleared once
  // writes commit. Covers both Liefermethode and Abholtermin writes.
  let pendingMutation = null;

  // Coalesce rapid applyState() calls triggered by the drawer-wide
  // MutationObserver (component-cart.js:429). Without this, every child
  // mutation in the drawer subtree (qty input, item add, etc.) fires its own
  // /cart.js fetch.
  let applyStateTimer = null;
  let lastAppliedMethod = null;

  async function fetchCart() {
    const res = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    if (!res.ok) {
      throw new Error('cart.js ' + res.status);
    }
    return res.json();
  }

  async function updateAttributes(attributes) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes })
    });
    if (!res.ok) {
      throw new Error('cart/update.js ' + res.status);
    }
    return res.json();
  }

  async function changeLine(line, properties) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line, properties })
    });
    if (!res.ok) {
      throw new Error('cart/change.js ' + res.status);
    }
    return res.json();
  }

  function applyClassToAllCartRoots(isAbholung) {
    document.querySelectorAll('[data-cart-root]').forEach(function (root) {
      const has = root.classList.contains(ABHOLUNG_CLASS);
      if (has !== isAbholung) {
        root.classList.toggle(ABHOLUNG_CLASS, isAbholung);
      }
    });
  }

  function syncHiddenInputs(method) {
    document.querySelectorAll('[data-cart-abholung-hidden]').forEach(function (input) {
      if (input.value !== method) {
        input.value = method;
      }
    });
  }

  function syncRadios(method) {
    document.querySelectorAll('[data-cart-abholung-toggle]').forEach(function (toggle) {
      if (toggle.dataset.cartAbholungCurrent !== method) {
        toggle.dataset.cartAbholungCurrent = method;
      }
      toggle.querySelectorAll('[data-cart-abholung-radio]').forEach(function (radio) {
        const shouldBeChecked = radio.value === method;
        if (radio.checked !== shouldBeChecked) {
          radio.checked = shouldBeChecked;
        }
      });
    });
  }

  function syncHiddenAbholterminInputs(iso, display) {
    const isoVal = iso || '';
    const displayVal = display || '';
    document.querySelectorAll('[data-cart-abholung-iso]').forEach(function (input) {
      if (input.value !== isoVal) {
        input.value = isoVal;
      }
    });
    document.querySelectorAll('[data-cart-abholung-display]').forEach(function (input) {
      if (input.value !== displayVal) {
        input.value = displayVal;
      }
    });
  }

  function syncConfirmRows(display) {
    document.querySelectorAll('[data-cart-abholung-confirm]').forEach(function (row) {
      const label = row.querySelector('[data-cart-abholung-confirm-label]');
      const newText = display || '';
      if (label && label.textContent !== newText) {
        label.textContent = newText;
      }
      const shouldHide = !display;
      const isHidden = row.hasAttribute('hidden');
      if (shouldHide && !isHidden) {
        row.setAttribute('hidden', '');
      } else if (!shouldHide && isHidden) {
        row.removeAttribute('hidden');
      }
    });
  }

  function syncHintRows(showHint) {
    document.querySelectorAll('[data-cart-abholung-hint]').forEach(function (hint) {
      const isHidden = hint.hasAttribute('hidden');
      if (showHint && isHidden) {
        hint.removeAttribute('hidden');
      } else if (!showHint && !isHidden) {
        hint.setAttribute('hidden', '');
      }
    });
  }

  function setMinMaxOnDateInputs() {
    const today = todayDateString();
    const max = maxDateString();
    document.querySelectorAll('[data-cart-abholung-date]').forEach(function (input) {
      if (input.min !== today) input.min = today;
      if (input.max !== max) input.max = max;
    });
  }

  function formatGermanDateOnly(dateString) {
    if (!dateString) return '';
    const target = new Date(dateString + 'T00:00');
    if (isNaN(target.getTime())) return '';
    const fmt = new Intl.DateTimeFormat('de-AT', {
      weekday: 'short',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
    return fmt.format(target);
  }

  function syncDateInputs(dateString) {
    const targetValue = dateString || '';
    document.querySelectorAll('[data-cart-abholung-date]').forEach(function (input) {
      // When Flatpickr owns the input, mirror via its API so the alt input
      // (visible "d.m.Y" companion) stays in sync. `triggerChange = false`
      // prevents an infinite event loop because the call sites that invoke
      // syncDateInputs are themselves change-event consumers.
      if (input._flatpickr && typeof input._flatpickr.setDate === 'function') {
        if (targetValue) {
          input._flatpickr.setDate(targetValue, false);
        } else {
          input._flatpickr.clear(false);
        }
      } else if (input.value !== targetValue) {
        input.value = targetValue;
      }
      if (input.hasAttribute('aria-invalid')) {
        input.removeAttribute('aria-invalid');
      }
    });
    const labelText = dateString ? formatGermanDateOnly(dateString) : '';
    document.querySelectorAll('[data-cart-abholung-date-value]').forEach(function (label) {
      const isFilled = label.dataset.cartAbholungDateFilled === 'true';
      if (labelText) {
        if (label.textContent !== labelText) {
          label.textContent = labelText;
        }
        if (!isFilled) {
          label.dataset.cartAbholungDateFilled = 'true';
        }
      } else {
        const emptyText = label.dataset.emptyText || 'Datum wählen';
        if (label.textContent !== emptyText) {
          label.textContent = emptyText;
        }
        if (isFilled) {
          delete label.dataset.cartAbholungDateFilled;
        }
      }
    });
    if (dateString) {
      document.querySelectorAll('[data-cart-abholung-date-trigger]').forEach(function (btn) {
        if (btn.hasAttribute('aria-invalid')) {
          btn.removeAttribute('aria-invalid');
        }
      });
    }
  }

  function slotSignature(dateString, slots) {
    return (dateString || '') + '|' + slots.map(function (s) {
      return pad2(s.getHours());
    }).join(',');
  }

  function populateTimeSelectsForDate(dateString, selectedHourString) {
    const slots = computeAvailableSlots(dateString);
    const signature = slotSignature(dateString, slots);

    document.querySelectorAll('[data-cart-abholung-time]').forEach(function (select) {
      // Skip rebuild while user is interacting with this select to avoid
      // destroying the open dropdown / picked option. Just update value.
      const userInteracting = document.activeElement === select;
      const signatureChanged = select.dataset.cartAbholungSignature !== signature;

      if (signatureChanged && !userInteracting) {
        select.innerHTML = '';
        if (!dateString) {
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Bitte wähle zuerst ein Datum';
          select.appendChild(placeholder);
          select.disabled = true;
        } else if (slots.length === 0) {
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Keine Slots an diesem Tag verfügbar';
          select.appendChild(placeholder);
          select.disabled = true;
        } else {
          select.disabled = false;
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Bitte Uhrzeit wählen';
          select.appendChild(placeholder);
          slots.forEach(function (slot) {
            const opt = document.createElement('option');
            const hh = pad2(slot.getHours());
            opt.value = hh + ':00';
            opt.textContent = hh + ':00 Uhr';
            select.appendChild(opt);
          });
        }
        select.dataset.cartAbholungSignature = signature;
      }

      // Set selected value idempotently.
      const desiredValue = (function () {
        if (!selectedHourString) return '';
        const exists = Array.prototype.some.call(select.options, function (o) {
          return o.value === selectedHourString;
        });
        return exists ? selectedHourString : '';
      })();
      if (select.value !== desiredValue) {
        select.value = desiredValue;
      }
      if (select.hasAttribute('aria-invalid')) {
        select.removeAttribute('aria-invalid');
      }
    });
  }

  async function setAbholtermin(iso, display) {
    pendingMutation = 'abholtermin';
    syncHiddenAbholterminInputs(iso, display);
    syncConfirmRows(display);
    syncHintRows(!display);
    try {
      await updateAttributes({
        [ATTR_ABHOLTERMIN]: iso || '',
        [ATTR_ABHOLTERMIN_DISPLAY]: display || ''
      });
    } catch (e) {
      console.warn('AumaerkAbholung: setAbholtermin failed', e);
    } finally {
      if (pendingMutation === 'abholtermin') {
        pendingMutation = null;
      }
    }
  }

  async function clearAbholtermin() {
    syncDateInputs('');
    populateTimeSelectsForDate('', '');
    await setAbholtermin('', '');
  }

  // Pickup not available on weekends or on AT public holidays. Uses the
  // shared Lieferung logic module for the holiday set (computed once per
  // controller mount + cached across years that fall inside the 14-day
  // horizon).
  function getAbholungBlackouts() {
    if (!window.AumaerkLieferungLogic) return new Set();
    const L = window.AumaerkLieferungLogic;
    const today = new Date();
    const thisYear = today.getFullYear();
    const holidays = L.austrianHolidays(thisYear);
    // 14-day horizon may cross into next year in late December.
    if (today.getMonth() === 11 && today.getDate() >= 18) {
      L.austrianHolidays(thisYear + 1).forEach(function (iso) { holidays.add(iso); });
    }
    return holidays;
  }

  function mountAbholungFlatpickr(dateInput, dateTrigger) {
    if (typeof window.flatpickr !== 'function') {
      // Fallback: drop readonly so user can still type, native picker may
      // open on focus in some browsers via stepper UI.
      dateInput.removeAttribute('readonly');
      return null;
    }
    if (dateInput.dataset.flatpickrMounted === 'true') {
      return null;
    }
    dateInput.dataset.flatpickrMounted = 'true';

    const blackouts = getAbholungBlackouts();
    const today = new Date();
    const minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + HORIZON_DAYS);

    return window.flatpickr(dateInput, {
      locale: 'de',
      dateFormat: 'Y-m-d',         // storage value (downstream code expects ISO)
      altInput: true,              // create a visible companion input
      altFormat: 'd.m.Y',          // German dd.mm.yyyy
      altInputClass: 'cart__abholung-date-input cart__abholung-date-input--alt',
      minDate: minDate,
      maxDate: maxDate,
      disableMobile: true,
      allowInput: false,
      clickOpens: true,
      disable: [
        function (date) {
          const dow = date.getDay();
          if (dow === 0 || dow === 6) return true; // So + Sa
          const iso = date.getFullYear() + '-'
            + (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1) + '-'
            + (date.getDate() < 10 ? '0' : '') + date.getDate();
          return blackouts.has(iso);
        }
      ],
      onChange: function (selectedDates, dateString) {
        // Mirror the value into the native change event listener pipeline
        // by firing a synthetic change event.
        dateInput.dispatchEvent(new Event('change', { bubbles: true }));
      },
      onOpen: function () {
        // Scroll the popup into view inside the cart drawer (matches the
        // Lieferung picker UX). Defer one frame so the calendar is in DOM
        // and we can measure it.
        requestAnimationFrame(function () {
          const drawerBody = dateInput.closest('.sidebar__body');
          const cal = (dateInput._flatpickr && dateInput._flatpickr.calendarContainer) || dateTrigger;
          if (!cal) return;
          if (drawerBody) {
            const targetTop = drawerBody.scrollTop
              + cal.getBoundingClientRect().top
              - drawerBody.getBoundingClientRect().top
              - 16;
            drawerBody.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
          } else if (typeof cal.scrollIntoView === 'function') {
            cal.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    });
  }

  function bindPickers() {
    setMinMaxOnDateInputs();

    // Format any server-rendered ISO date into German label immediately
    document.querySelectorAll('[data-cart-abholung-date]').forEach(function (input) {
      if (input.value) {
        syncDateInputs(input.value);
      }
    });

    document.querySelectorAll('[data-cart-abholung-picker]').forEach(function (picker) {
      if (picker.dataset.cartAbholungPickerBound === 'true') {
        return;
      }
      picker.dataset.cartAbholungPickerBound = 'true';

      const dateInput = picker.querySelector('[data-cart-abholung-date]');
      const dateTrigger = picker.querySelector('[data-cart-abholung-date-trigger]');
      const timeSelect = picker.querySelector('[data-cart-abholung-time]');

      if (dateInput) {
        mountAbholungFlatpickr(dateInput, dateTrigger);

        dateInput.addEventListener('change', function () {
          const dateString = dateInput.value;
          if (!dateString) {
            syncDateInputs('');
            populateTimeSelectsForDate('', '');
            setAbholtermin('', '');
            return;
          }
          // Defensive: Flatpickr's disable callback already blocks Sa/So +
          // holidays, but keep this guard for the rare case Flatpickr fails
          // to load and we fall back to a permissive native input.
          const target = new Date(dateString + 'T00:00');
          const dow = isNaN(target.getTime()) ? -1 : target.getDay();
          if (dow === 0 || dow === 6) {
            dateInput.value = '';
            if (dateTrigger) dateTrigger.setAttribute('aria-invalid', 'true');
            syncDateInputs('');
            populateTimeSelectsForDate('', '');
            setAbholtermin('', '');
            return;
          }
          syncDateInputs(dateString);
          populateTimeSelectsForDate(dateString, '');
          setAbholtermin('', '');
        });
      }

      if (timeSelect) {
        timeSelect.addEventListener('change', function () {
          const dateString = dateInput && dateInput.value;
          const hourString = timeSelect.value;
          if (!dateString || !hourString) {
            return;
          }
          const iso = buildIsoString(dateString, hourString);
          const parsed = parseAbholterminIso(iso);
          if (!parsed) {
            return;
          }
          const display = formatGermanDisplay(parsed);
          setAbholtermin(iso, display);
        });
      }
    });
  }

  function applyMethodToDOM(method) {
    applyClassToAllCartRoots(method === 'Abholung');
    syncHiddenInputs(method);
    syncRadios(method);
  }

  async function setMethod(method) {
    if (method !== 'Lieferung' && method !== 'Abholung') {
      return;
    }

    const isAbholung = method === 'Abholung';
    pendingMutation = method;
    applyMethodToDOM(method);
    lastAppliedMethod = method;

    try {
      const attrUpdate = { [ATTR_METHOD]: method };
      if (isAbholung) {
        attrUpdate['Shipping-Date'] = '';
        attrUpdate['Checkout-Method'] = '';
      } else {
        attrUpdate[ATTR_ABHOLTERMIN] = '';
        attrUpdate[ATTR_ABHOLTERMIN_DISPLAY] = '';
        syncHiddenAbholterminInputs('', '');
        syncConfirmRows('');
        syncHintRows(true);
        syncDateInputs('');
        populateTimeSelectsForDate('', '');
      }
      await updateAttributes(attrUpdate);
    } catch (e) {
      console.warn('AumaerkAbholung: setMethod failed', e);
    } finally {
      if (pendingMutation === method) {
        pendingMutation = null;
      }
    }
  }

  function applyStateNow() {
    if (pendingMutation) {
      return;
    }
    fetchCart().then(async function (cart) {
      if (pendingMutation) {
        return;
      }
      const attrs = cart.attributes || {};
      const method = attrs[ATTR_METHOD] === 'Abholung' ? 'Abholung' : 'Lieferung';
      let iso = typeof attrs[ATTR_ABHOLTERMIN] === 'string' ? attrs[ATTR_ABHOLTERMIN] : '';
      let display = typeof attrs[ATTR_ABHOLTERMIN_DISPLAY] === 'string' ? attrs[ATTR_ABHOLTERMIN_DISPLAY] : '';

      if (method === 'Abholung' && iso && isAbholterminExpired(iso)) {
        iso = '';
        display = '';
        pendingMutation = 'expiry-clear';
        try {
          await updateAttributes({
            [ATTR_ABHOLTERMIN]: '',
            [ATTR_ABHOLTERMIN_DISPLAY]: ''
          });
        } catch (e) {
          console.warn('AumaerkAbholung: expiry clear failed', e);
        } finally {
          if (pendingMutation === 'expiry-clear') {
            pendingMutation = null;
          }
        }
      }

      if (method !== lastAppliedMethod) {
        lastAppliedMethod = method;
        applyMethodToDOM(method);
      }

      const dateString = iso ? iso.split('T')[0] : '';
      const hourString = iso ? iso.split('T')[1] : '';
      syncDateInputs(dateString);
      populateTimeSelectsForDate(dateString, hourString);
      syncHiddenAbholterminInputs(iso, display);
      syncConfirmRows(display);
      syncHintRows(!display);
    }).catch(function (e) {
      console.warn('AumaerkAbholung: applyState failed', e);
    });
  }

  function applyState() {
    if (applyStateTimer) {
      return;
    }
    applyStateTimer = setTimeout(function () {
      applyStateTimer = null;
      applyStateNow();
    }, 50);
  }

  function bindToggles() {
    document.querySelectorAll('[data-cart-abholung-toggle]').forEach(function (toggle) {
      if (toggle.dataset.cartAbholungBound === 'true') {
        return;
      }
      toggle.dataset.cartAbholungBound = 'true';

      toggle.addEventListener('change', function (event) {
        const target = event.target;
        if (!target || target.dataset.cartAbholungRadio === undefined) {
          return;
        }
        setMethod(target.value);
      });
    });
  }

  function init() {
    bindToggles();
    bindPickers();
    applyState();
  }

  window.AumaerkAbholung = {
    setMethod: setMethod,
    setAbholtermin: setAbholtermin,
    clearAbholtermin: clearAbholtermin,
    applyState: applyState,
    bindToggles: bindToggles,
    bindPickers: bindPickers,
    isAbholterminExpired: isAbholterminExpired
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
